import { TranslateService } from '@ngx-translate/core';
import { DialogObject } from '@/components/dialog/dialog.types';
import { ContractingAuthorityRepository } from '@/store/contracting-authority-state/contracting-authority-state.repository';

interface getContractingAuthorityDeleteObjectProps {
  t: TranslateService;
  store?: ContractingAuthorityRepository;
  representation?: string;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getContractingAuthorityDeleteObject = ({
  t,
  store,
  representation,
  action,
  toggleVisiblity,
}: getContractingAuthorityDeleteObjectProps): DialogObject => {
  return {
    title: t.instant(`settings.contractingAuthority.ac.deleteConfirm`, {
      representation: representation,
    }),
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'common.dialog.confirm',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'common.dialog.cancel',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
